import makeExternalTab from './makeExternalTab';
import AccountsTab from './Accounts';
import CustomerMigrationTab from './CustomerMigration';
import PermissionSetsTab from './PermissionSets';

const DEFAULT_TABS = [
  AccountsTab,
  CustomerMigrationTab,
  PermissionSetsTab,

  /*
  makeExternalTab({
    label: 'Example.com',
    url: '/example',
    src: 'http://example.com',
  }),

  makeExternalTab({
    label: 'Example.com 2',
    url: '/example2',
    src: 'http://example.com',
  }),
  */

  makeExternalTab({
    label: 'DS addAccount',
    url: '/legacy/addAccount',
    src: 'https://webadmin-iad-s1.dialsource.com/addAccount',
  }),

  makeExternalTab({
    label: 'DS Super Admin',
    url: '/legacy/ds-superadmin',
    src: 'https://webadmin-iad-s1.dialsource.com/dsAdmin/accountSettings/00D36000000J4Fs/0051I000000ZRYQ',
  }),

  makeExternalTab({
    label: 'DS Management',
    url: '/legacy/ds-management',
    src: 'https://webadmin-iad-s1.dialsource.com/settings/00D36000000J4Fs/00536000008xj9o/0',
  }),

  makeExternalTab({
    label: 'DS Admin',
    url: '/legacy/ds-admin',
    src: 'https://webadmin-iad-s1.dialsource.com/admin/managerRecordings/00D36000000J4Fs/00536000008xj9o/00D36000000J4Fs%21AQMAQGUK9vH6UK7mLzTeehuvqjfDZiCZtkY5zOLifUu7eduA.yrewmJYhEm6MPACpTwaUueqFqRgsR7cPffcNf95JgH7u2Je/0/https://ds-bolt-dev-ed.my.salesforce.com/services/Soap/u/35.0/00D36000000J4Fs',
  }),

  makeExternalTab({
    label: 'DS User',
    url: '/legacy/ds-user',
    src: 'https://webadmin-iad-s1.dialsource.com/user/voicemailRecordings/00D36000000J4Fs/00536000008xj9o/00D36000000J4Fs%21AQMAQIr1opq.swGsZOZs8GZrMePqvHdIMHOkBMMZqd1ic5suU.P8xt10g6iQ6.KRGGaSf.Pr.7sRTs3uq5zizeXEg_sPYsFn/0/salesforce-crm/https://ds-bolt-dev-ed.my.salesforce.com/services/Soap/u/35.0/00D36000000J4Fs',
  }),
];

export default DEFAULT_TABS;
